import { Component } from '@angular/core';
import { AppData } from '../../../app-data';
import { Uom } from '../../../model/api/assets/uom';
import { Param } from '../../../model/common/param';
import { GenericTableList } from '../../generic/generic.table.list';

@Component({
    selector: 'app-uom-list',
    templateUrl: '../../generic/generic.table.list.html'
})
export class UomListComponent extends GenericTableList<Uom, number> {
    public listName: string = 'UOMS';

    constructor() {
        super('code', 'asc', '');
        this.columns = AppData.ColumnDefinitions[this.listName];
    }

    public refresh(filters: Array<Param>) {
        this.columns = AppData.ColumnDefinitions[this.listName];
        super.refresh(filters);
    }
}
